/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)

import DisableAutocomplete from 'vue-disable-autocomplete'
Vue.use(DisableAutocomplete)

// axios
import axios from './axios.js'
Vue.prototype.$http = axios

// Une partie du code (vues efactura, broker, outlay, etransport...) utilise
// `import axios from 'axios'` directement (sans passer par notre instance).
// On enregistre un intercepteur global sur l'axios par défaut pour que ces
// requêtes injectent quand même le JWT.
import globalAxios from 'axios'
globalAxios.interceptors.request.use(config => {
  if (typeof localStorage !== 'undefined') {
    const token = localStorage.getItem('accessToken')
    if (token) config.headers['x-access-token'] = token
    const td = localStorage.getItem('xylo:trusted-device-token')
    if (td) config.headers['x-trusted-device'] = td
  }
  return config
}, err => Promise.reject(err))
// API Calls
import './http/requests'

// mock
import './fake-db/index.js'

// Theme Configurations
import '../themeConfig.js'


// ACL
import acl from './acl/acl'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'

// Fonts
import '@fontsource/noto-sans-gurmukhi/400.css' // Noto Sans Gurmukhi font
import './helpers/jspdfTextSafe.js' // PDF : diacritiques roumains lisibles (Helvetica + Amiri)

// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// i18n
import i18n from './i18n/i18n'


// Vuexy Admin Filters
import './filters/filters'


// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)


// Tour
import VueTour from 'vue-tour'
Vue.use(VueTour)
require('vue-tour/dist/vue-tour.css')


// VeeValidate
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)


// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
  load: {
    // Add your API key here
    key: 'AIzaSyDW5Ik0oyDhx0gaCjOyWhMehsBcuSOPqJo',
    libraries: 'places' // This is required if you use the Auto complete plug-in
  }
})

import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

require('./assets/css/iconfont.css')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  acl,
  render: h => h(App)
}).$mount('#app')
